<h1>Favourites</h1>
<p>Click <strong>Details</strong> to expand. <span style="color: red;"><strong>Max 100 songs</strong></span></p>
<p><app-player-mode-toggle /></p>
<br />
<mat-list>
  @if (favourites().length > 0) {
  <div fxLayout="row wrap" fxLayoutGap="8px">
    @for (favourite of favourites(); track favourite.id) {
    <div fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-sm="calc(20% - 6px)" fxFlex.gt-md="calc(20% - 6px)">
      <mat-card class="favourite-card-compact">
        <!-- Header: Song name + Remove button -->
        <div class="song-header">
          <mat-icon (click)="removeFromFavourites(favourite.id);" class="remove-btn"
            title="Remove from Favourites">clear</mat-icon>
          <span class="song-name" title="{{favourite?.name}}">{{favourite?.name}}</span>
          <app-deezer-link kind="track" [id]="favourite.id" [name]="favourite.name" />
        </div>

        <!-- Always visible: Audio player -->
        <app-track-player [trackId]="favourite.id" [previewUrl]="favourite.preview_url" />

        <!-- Expandable button -->
        <button mat-button (click)="toggleExpand(favourite.id)" class="expand-btn-mini">
          <mat-icon>{{isExpanded(favourite.id) ? 'expand_less' : 'expand_more'}}</mat-icon>
        </button>

        <!-- Expanded content -->
        @if (isExpanded(favourite.id)) {
        <div class="expanded-content">
          <div class="divider"></div>
          <p style="font-size: 0.75rem; margin: 4px 0;">
            <strong>Artist:</strong>
            @for (a of favourite.artists; track a.id) {
            <a [routerLink]="['/artist', a.id]">{{a.name}}</a>{{!$last ? ', ' : ''}}
            }
          </p>
          <p style="font-size: 0.75rem; margin: 4px 0;"><strong>Album:</strong> <a [routerLink]="['/album', favourite.album.id]">{{favourite.album.name}}</a></p>
          <p style="font-size: 0.75rem; margin: 4px 0;"><strong>Duration:</strong> {{(favourite.duration_ms / 60000).toFixed(2)}} min</p>
        </div>
        }
      </mat-card>
    </div>
    }
  </div>
  } @else {
  <mat-card>
    <mat-card-content>
      <p>No favourites added yet.</p>
    </mat-card-content>
  </mat-card>
  }
</mat-list>

<br />
<div class="pagination-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
  <button mat-raised-button color="primary" [disabled]="page() <= 1" (click)="changePage(-1)">
    <mat-icon>chevron_left</mat-icon> Previous
  </button>

  <span class="page-info">
    Page <strong>{{page()}}</strong> of {{ totalItems() > 0 ? Math.ceil(totalItems() / pageSize) : 1 }}
    <br />
    <small>({{totalItems()}} / 100 tracks)</small>
  </span>

  <button mat-raised-button color="primary" [disabled]="page() >= 10 || page() >= Math.ceil(totalItems() / pageSize)"
    (click)="changePage(1)">
    Next <mat-icon>chevron_right</mat-icon>
  </button>
</div>
<br /><br />